import { Title } from "rizzui";
import ModalButton from "@/app/shared/modal-button.tsx";
import { CreateEditApiKey } from "@/app/app-shared/api-key/create-edit/create-edit-api-key.tsx";
import ControlledTable from "@/components/controlled-table";
import { useMemo } from "react";
import { Roles } from "@/utilities/types/Users.ts";
import { useColumn } from "@/hooks/use-column.ts";
import { GetColumns } from "@/app/app-shared/api-key/table/columns.tsx";
import { useModal } from "@/app/shared/modal-views/use-modal.ts";
import APIKeyRepository from "@/utilities/repositories/ApiKey.ts";
import { useTableServer } from "@/hooks/useTableServer.tsx";
import useApi from "@/hooks/useApi.tsx";
import toast from "react-hot-toast";

const ApiKeyTable = () => {
  const {
    handleReset,
    isLoading,
    tableData,
    currentPage,
    totalItems,
    handleSort,
    handlePaginate,
    pageSize,
    handleChangePageSize,
  } = useTableServer({
    server: {
      request: APIKeyRepository.getAPIKey,
    },
  });

  const { request: deleteApiKey } = useApi({
    request: APIKeyRepository.deleteApiKey,
  });
  const { openModal } = useModal();

  const onHeaderCellClick = (value: string) => ({
    onClick: () => {
      handleSort(value);
    },
  });

  const onDeleteItem = async (id: string) => {
    try {
      await deleteApiKey(id);
      toast.success("Delete Api key success!");
      handleReset();
    } catch (err) {
      console.log(err);
      toast.error("Delete API key failed");
    }
  };
  const onEditItem = (row: any) => {
    openModal({
      view: (
        <CreateEditApiKey
          refetchData={() => handlePaginate(currentPage)}
          row={row}
        />
      ),
      customSize: "600px",
    });
  };

  const columns = useMemo(
    () =>
      GetColumns({
        data: tableData,
        onDeleteItem,
        onHeaderCellClick,
        reset: handleReset,
        role: Roles.ADMIN,
        onEditItem,
      }),
    [onHeaderCellClick, onDeleteItem, tableData, onEditItem]
  );

  const { visibleColumns } = useColumn(columns);

  return (
    <div>
      <div className="mb-4 w-full flex items-center justify-between">
        <Title as="h5" className="@xl:basis-auto text-xl md:text-2xl">
          API Key
        </Title>
        <ModalButton
          view={<CreateEditApiKey refetchData={handleReset} />}
          label="Add API Key"
          customSize="600px"
          className="mt-0 w-auto"
        />
      </div>
      <div>
        <ControlledTable
          variant="modern"
          data={tableData}
          isLoading={isLoading}
          showLoadingText={true}
          // @ts-ignore
          columns={visibleColumns}
          paginatorOptions={{
            pageSize,
            setPageSize: handleChangePageSize,
            total: totalItems,
            current: currentPage,
            onChange: (page: number) => handlePaginate(page),
          }}
          className="rounded-md border border-muted text-sm shadow-sm [&_.rc-table-placeholder_.rc-table-expanded-row-fixed>div]:h-60 [&_.rc-table-placeholder_.rc-table-expanded-row-fixed>div]:justify-center [&_.rc-table-row:last-child_td.rc-table-cell]:border-b-0 [&_thead.rc-table-thead]:border-t-0"
        />
      </div>
    </div>
  );
};

export default ApiKeyTable;
